// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmtpSetup_input_container__uxSWN {
  width: 270px !important;
  padding-right: 40px !important;
}

.SmtpSetup_textContainer__GDF81 {
  width: 800px;
}

.SmtpSetup_connected_account_container__q0FNo {
  display: flex;
  gap: 30px;
}

.SmtpSetup_input_row__OAdSD {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.SmtpSetup_input_row_vertically_spaced__tgGAm {
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;
  flex-direction: column;
}

.SmtpSetup_input_row_2_columns__3aCny {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  max-width: 656px;
  flex-wrap: wrap;
}

.SmtpSetup_label__aJdiY {
  padding: 0px;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.SmtpSetup_label__aJdiY b {
  font-size: 12px;
  color: var(--color-theme-red);
  padding-left: 5px;
}

.SmtpSetup_btn_container__q5XUu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 0px 10px 0px;
}

.SmtpSetup_btn_container_validate__NOJVh {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 5px;
}

.SmtpSetup_validate_btn__G9YWE {
  color: var(--color-theme-10) !important;
  border: 1px solid var(--color-theme-0) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.SmtpSetup_save_activate_btn__N92Xr {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.SmtpSetup_save_disconnect_btn__s6qW\\+ {
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  width: 174px;
  height: 41px;
  font-weight: bold !important;
}

.SmtpSetup_save_disconnect_btn_oauth__caeFf {
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  width: 174px;
  height: 41px;
  margin-top: 15px !important;
  font-weight: bold !important;
}

.SmtpSetup_save_emailname_btn_oauth__XZpTx {
  color: var(--color-theme-blue) !important;
  border: 1px solid var(--color-theme-blue) !important;
  width: 194px;
  height: 41px;
  margin-top: 15px !important;
  font-weight: bold !important;
}

.SmtpSetup_circular_progress_container__oqvHm {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 60px;
}

.SmtpSetup_smtp_text__yp54x {
 margin-bottom: 15px;
}

.SmtpSetup_gray_bar_devider__sUUmM{
   width: 100%;
   height: 5px;
   background-color: #E0E0E0;
   margin: 20px 0;
}

/* TODO define a varible for the links */
.SmtpSetup_link__zo\\+DF {
  color: #ff6666;
}

.SmtpSetup_checkbox_container__x\\+hmW {
  display: flex;
  align-items: center;
  margin-bottom: -15px;
}

.SmtpSetup_btn_select_email_provider__CRjyO {
  color: var(--color-theme-10) !important;
  border-color: var(--color-theme-10) !important;
  width: 370px !important;
  display: flex !important;
  justify-content: space-between !important;
}

.SmtpSetup_menu_item__8p7VX {
  display: flex;
  align-items: center;
}

.SmtpSetup_menu_item__8p7VX p {
  margin: 2px;
  padding-right: 20px;
}

.SmtpSetup_check_icon__02h3L {
  color: var(--color-theme-10, #1976d2);
  font-size: 1.25rem;
}

.SmtpSetup_basic_smtp_inputs_container__NmJmC {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/SmtpSetup/SmtpSetup.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;GACG,WAAW;GACX,WAAW;GACX,yBAAyB;GACzB,cAAc;AACjB;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".input_container {\n  width: 270px !important;\n  padding-right: 40px !important;\n}\n\n.textContainer {\n  width: 800px;\n}\n\n.connected_account_container {\n  display: flex;\n  gap: 30px;\n}\n\n.input_row {\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n}\n\n.input_row_vertically_spaced {\n  display: flex;\n  align-items: flex-start;\n  padding-bottom: 20px;\n  flex-direction: column;\n}\n\n.input_row_2_columns {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  max-width: 656px;\n  flex-wrap: wrap;\n}\n\n.label {\n  padding: 0px;\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.label b {\n  font-size: 12px;\n  color: var(--color-theme-red);\n  padding-left: 5px;\n}\n\n.btn_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 16px 0px 10px 0px;\n}\n\n.btn_container_validate {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-top: 16px;\n  padding-bottom: 5px;\n}\n\n.validate_btn {\n  color: var(--color-theme-10) !important;\n  border: 1px solid var(--color-theme-0) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.save_activate_btn {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.save_disconnect_btn {\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  width: 174px;\n  height: 41px;\n  font-weight: bold !important;\n}\n\n.save_disconnect_btn_oauth {\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  width: 174px;\n  height: 41px;\n  margin-top: 15px !important;\n  font-weight: bold !important;\n}\n\n.save_emailname_btn_oauth {\n  color: var(--color-theme-blue) !important;\n  border: 1px solid var(--color-theme-blue) !important;\n  width: 194px;\n  height: 41px;\n  margin-top: 15px !important;\n  font-weight: bold !important;\n}\n\n.circular_progress_container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 60px;\n}\n\n.smtp_text {\n margin-bottom: 15px;\n}\n\n.gray_bar_devider{\n   width: 100%;\n   height: 5px;\n   background-color: #E0E0E0;\n   margin: 20px 0;\n}\n\n/* TODO define a varible for the links */\n.link {\n  color: #ff6666;\n}\n\n.checkbox_container {\n  display: flex;\n  align-items: center;\n  margin-bottom: -15px;\n}\n\n.btn_select_email_provider {\n  color: var(--color-theme-10) !important;\n  border-color: var(--color-theme-10) !important;\n  width: 370px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.menu_item {\n  display: flex;\n  align-items: center;\n}\n\n.menu_item p {\n  margin: 2px;\n  padding-right: 20px;\n}\n\n.check_icon {\n  color: var(--color-theme-10, #1976d2);\n  font-size: 1.25rem;\n}\n\n.basic_smtp_inputs_container {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input_container": `SmtpSetup_input_container__uxSWN`,
	"textContainer": `SmtpSetup_textContainer__GDF81`,
	"connected_account_container": `SmtpSetup_connected_account_container__q0FNo`,
	"input_row": `SmtpSetup_input_row__OAdSD`,
	"input_row_vertically_spaced": `SmtpSetup_input_row_vertically_spaced__tgGAm`,
	"input_row_2_columns": `SmtpSetup_input_row_2_columns__3aCny`,
	"label": `SmtpSetup_label__aJdiY`,
	"btn_container": `SmtpSetup_btn_container__q5XUu`,
	"btn_container_validate": `SmtpSetup_btn_container_validate__NOJVh`,
	"validate_btn": `SmtpSetup_validate_btn__G9YWE`,
	"save_activate_btn": `SmtpSetup_save_activate_btn__N92Xr`,
	"save_disconnect_btn": `SmtpSetup_save_disconnect_btn__s6qW+`,
	"save_disconnect_btn_oauth": `SmtpSetup_save_disconnect_btn_oauth__caeFf`,
	"save_emailname_btn_oauth": `SmtpSetup_save_emailname_btn_oauth__XZpTx`,
	"circular_progress_container": `SmtpSetup_circular_progress_container__oqvHm`,
	"smtp_text": `SmtpSetup_smtp_text__yp54x`,
	"gray_bar_devider": `SmtpSetup_gray_bar_devider__sUUmM`,
	"link": `SmtpSetup_link__zo+DF`,
	"checkbox_container": `SmtpSetup_checkbox_container__x+hmW`,
	"btn_select_email_provider": `SmtpSetup_btn_select_email_provider__CRjyO`,
	"menu_item": `SmtpSetup_menu_item__8p7VX`,
	"check_icon": `SmtpSetup_check_icon__02h3L`,
	"basic_smtp_inputs_container": `SmtpSetup_basic_smtp_inputs_container__NmJmC`
};
export default ___CSS_LOADER_EXPORT___;
